import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface MetricCardProps {
  label: string;
  /** Pass `<Money />` (or a money()-formatted string) for currency values. */
  value: ReactNode;
  icon?: ReactNode;
  trend?: 'up' | 'down' | 'neutral';
  subtitle?: string;
  className?: string;
}

export default function MetricCard({ label, value, icon, subtitle, className = '' }: MetricCardProps) {
  return (
    <div
      className={cn(
        'bg-surface-card border border-border rounded-[var(--radius-surface)] p-4',
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="min-w-0">
          <p className="t-label text-ink-soft">{label}</p>
          <p className="t-num-hero mt-1 text-green-900">{value}</p>
          {subtitle && <p className="mt-1 text-xs text-ink-faint">{subtitle}</p>}
        </div>
        {icon && (
          <span className="shrink-0 rounded-[var(--radius-control)] bg-green-100 p-2 text-green-700">
            {icon}
          </span>
        )}
      </div>
    </div>
  );
}
